import axios from 'axios';
import { API_DOMAIN } from '../../../components/constants';
import { putSignedUpload } from '../../../components/internalChat/internalChatApi';
import { assertSessionCurrent, sessionTicket } from '../../../utils/sessionLifecycle';
import { aiChatAttachmentsApi } from '../../../components/ai/constants';

const unwrap = response => {
  if (response.data?.success !== true || !response.data.data) throw Object.assign(new Error('AI file upload failed.'), { response });
  return response.data.data;
};
// Same cloud initiate → signed PUT → complete flow as internal chat, with the
// explicit AI purpose authorized by the handover. Never fall back to conversion.
export async function uploadAiChatAttachment(chatId, file) {
  const ticket = sessionTicket(), config = { __srmInitiatingSessionTicket: ticket };
  const initiated = unwrap(await axios.post(`${API_DOMAIN}/cloud_storage/uploads/initiate`, {
    purpose: 'ai_chat_attachment', original_name: file.name, mime_type: file.type, size_bytes: file.size,
  }, config));
  assertSessionCurrent(ticket);
  const id = initiated.upload?.id;
  if (!id || !initiated.upload_url || initiated.method !== 'PUT') throw new Error('The file upload could not be started.');
  // This helper uses a bare XMLHttpRequest: exactly the signed headers and raw
  // File bytes, without axios interceptors, SRM credentials, or image conversion.
  await putSignedUpload({ uploadUrl: initiated.upload_url, requiredHeaders: initiated.required_headers, file });
  assertSessionCurrent(ticket);
  const completed = unwrap(await axios.post(`${API_DOMAIN}/cloud_storage/uploads/${encodeURIComponent(id)}/complete`, {}, config));
  assertSessionCurrent(ticket);
  if (String(completed.id) !== String(id) || completed.upload_status !== 'uploaded') throw new Error('The file upload has not finished.');
  const attachment = unwrap(await axios.post(aiChatAttachmentsApi(chatId), {
    upload_id: id, file_name: file.name, mime_type: file.type,
  }, config));
  assertSessionCurrent(ticket);
  return attachment;
}
